import http from "./http";

// GET ALL REQUESTS
export const getPayments = async () => {
  const res = await http.get(
    "live_working_logic/get_all_requests"
  );
  return res.data;
};

// UPDATE STATUS
export const updatePaymentStatus = async (formData) => {
  const res = await http.post(
    "live_working_logic/update_request_status",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      transformRequest: (data) => data,
    }
  );
  return res.data;
};